<template>
  <footer class="container mt-auto footer-fixed-bottom">
    <nav class="navbar navbar-expand-lg navbar-light navbar-main flex-wrapper">
      <div>
          <router-link :to="'/'" class="navbar-brand logo">
            <img src="../../assets/logo-white.png" alt="footer logo" style="width: 20%">
          </router-link>
        <p> {{ $t('footer.logoText') }}</p>
      </div>
      <ul class="ml-auto footer-list">
        <li class="footer-internal-link">
            <a :href="storeLocationsUrl" target="_blank">
                {{ $t('footer.links.storeLocations') }}
            </a>
        </li>
        <li class="footer-internal-link">
            <a :href="faqUrl" target="_blank">
                {{ $t('footer.links.faq') }}
            </a>
        </li>
        <li class="footer-internal-link">
            <a :href="supportCalLUsUrl" target="_blank">
                {{ $t('footer.links.supportCalLUs') }}
            </a>
        </li>
        <li class="footer-internal-link">
            <a :href="supportMailUsUrl" target="_blank">
                {{ $t('footer.links.supportMailUs') }}
            </a>
        </li>
        <li class="footer-internal-link">
            <a :href="websiteUrl" target="_blank">
                {{ $t('footer.links.website') }}
            </a>
        </li>
        <li class="footer-social-link">
            <a :href="facebookUrl" target="_blank">
                <img src="../../assets/images/social-icons/fb-icon.png" alt="facebook logo">
            </a>
        </li>
        <li class="footer-social-link">
            <a :href="youtubeUrl" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
                    <g>
                        <g opacity=".8">
                            <path fill="#fff" d="M2.734.324a2.073 2.073 0 1 0-.003 4.146A2.073 2.073 0 0 0 2.734.324zM.66 18.613h4.03V6.505H.658zM14.565 6.221c-2.14 0-3.094 1.177-3.63 2v.04h-.027a.494.494 0 0 1 .028-.04V6.505H6.912c.053 1.136 0 12.108 0 12.108h4.024V11.85c0-.362.027-.722.133-.98.291-.725.953-1.472 2.064-1.472 1.46 0 2.04 1.109 2.04 2.737v6.478H19.2v-6.944c0-3.718-1.985-5.448-4.635-5.448z" />
                        </g>
                    </g>
                </svg>
            </a>
        </li>
        <li class="footer-social-link">
            <a :href="instagramUrl" target="_blank">
                <img src="../../assets/images/social-icons/insta-icon.png" alt="instagram logo">
            </a>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script>
import Footer from './Footer';
export default Footer;
</script>
